import { render } from "./AqsAppointmentType.vue?vue&type=template&id=3e9396c9&ts=true"
import script from "./AqsAppointmentType.vue?vue&type=script&lang=ts"
export * from "./AqsAppointmentType.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__